// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2VLla","insightsList":"newBusinessInsightsMenu_insightsList__1iv7u","active":"newBusinessInsightsMenu_active__KeVaO"};